import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { BuildType } from '@shared/enums/build.type';
import { EnvironmentService } from '@services/utils/environment.service';

/**
 * For given build types, blocks access and redirects.
 * @param exceptionBuilds — builds for which the route is hidden
 * @param redirectTo — optional path to redirect to (default: ['/'])
 */
export const contentHiddenGuard = (exceptionBuilds: BuildType[] = [], redirectTo?: string[]) => {
  return () => {
    const router = inject(Router);
    const environmentService = inject(EnvironmentService);

    if (exceptionBuilds.includes(environmentService.currentBuild)) {
      return router.createUrlTree(redirectTo ?? ['/']);
    }
    return true;
  };
};
